import React, { Suspense, lazy } from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../WidgetBox';
import { withModuleData, WithModuleData } from '../../_hoc/withModuleData';
import reduxConnectContainer from './ExhibitionistBox.container';
import ConfigPopover from '../../_partials/ConfigPopover';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';

const ExhibitionistEditForm = lazy(() =>
  import(/* webpackChunkName: "owner" */ './ExhibitionistEditForm')
);

export enum ExhibitionistBoxType {
  TALL = 'tall',
  STRIP = 'strip',
}

export interface Props {
  moduleId: number;
  exhibitionistType: ExhibitionistBoxType;
  title: string;
  seeAllUrl?: string;
  isEmpty?: boolean;
  emptyView?: React.ReactNode;
  children: (boxProps) => React.ReactNode;
}

const defaultProps = {
  placement: 'bottom',
};

export type ExhibitionistBoxProps = Props &
  WidgetBoxProps &
  WithModuleData &
  WithTranslation;

const enhance = compose(
  reduxConnectContainer,
  withModuleData,
  withTranslation()
);
class ExhibitionistBox extends React.Component<ExhibitionistBoxProps> {
  static defaultProps = defaultProps;
  render() {
    const {
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      emptyView,
      children,
      moduleData: { sourceType, viewMode, slideImageFit },
      ...props
    } = this.props;

    return (
      <WidgetBox
        header={
          props.title || props.t(`widgets.exhibitionist.source.${sourceType}`)
        }
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        hasMore={props.hasMore}
        seeAllUrl={props.seeAllUrl}
        widgetMenuRenderer={this.renderEditMenu}
        moduleId={props.moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={props.isEmpty}
        emptyView={emptyView}
      >
        {children({ ...props, sourceType, viewMode, slideImageFit })}
      </WidgetBox>
    );
  }

  renderEditMenu = closeMenu => {
    return (
      <ConfigPopover width={266} onClose={closeMenu} withPaddings={false}>
        <Suspense fallback={<LoadingIndicator />}>
          <ExhibitionistEditForm
            moduleId={this.props.moduleId}
            exhibitionistType={this.props.exhibitionistType}
            close={closeMenu}
          />
        </Suspense>
      </ConfigPopover>
    );
  };
}

export default enhance(ExhibitionistBox) as React.ComponentType<Props>;
